// src/apollo/cache.js

import { InMemoryCache, makeVar } from "@apollo/client";

// Reactive variables for your local state
export const scrapedResultsVar = makeVar([]);
export const searchTitleVar = makeVar("");

// The single cache instance for your entire application
export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        scrapedResults: {
          read: () => scrapedResultsVar(),
        },
        searchTitle: {
          read: () => searchTitleVar(),
        },
      },
    },
  },
});
